import { render, staticRenderFns } from "./NewAssetRegistry.vue?vue&type=template&id=469761b4&scoped=true&"
import script from "./NewAssetRegistry.vue?vue&type=script&lang=js&"
export * from "./NewAssetRegistry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "469761b4",
  null
  
)

export default component.exports